import { FC } from "react";
import { IconPropsType } from ".";

export const Pin: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5877 1.88836L11.1105 0.410986C10.4666 -0.229499 9.29141 -0.109386 8.50545 0.687554L7.11195 2.07756H7.11207C6.96833 2.22401 6.78914 2.33062 6.59177 2.38691L3.86303 3.14008C3.11714 3.34391 2.73512 4.27901 3.20814 4.74842L8.26893 9.79183C8.7383 10.2649 9.67337 9.88284 9.87705 9.13684L10.6301 6.40772H10.6302C10.6864 6.21035 10.793 6.03114 10.9394 5.88735L12.3292 4.49366C13.1079 3.70038 13.228 2.54697 12.5876 1.88833L12.5877 1.88836Z"
        fill={props.color}
      />
      <path d="M0 13L5 9.11297L3.88697 8L0 13Z" fill={props.color} />
    </svg>
  );
};
